import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  overflow-y: auto;
  padding-right: 16px;
  min-height: 0;
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${COLORS.secondaryLight};
    border-radius: 4px;
  }

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding-right: 12px;
  }
`

export const StyleCard = styled.button`
  border: 1px solid ${COLORS.borderColor};
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 113px;
  background-color: ${COLORS.secondaryDark};

  &:hover {
    border: 2px solid ${COLORS.primaryDark};
    box-shadow: inset 0 0 0 2px ${COLORS.white};
  }
`

export const Thumbnail = styled.img`
  width: 120px;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
`
